export default __webpack_public_path__ + "static/media/meterreading-1.345ef2ea.png";